export const platformList = ['京东', '淘宝/天猫', '拼多多', '唯品会', '美团', '微博']
export const icomMap = {
  京东: 'jd',
}
export const platformIcon = {
  '淘宝/天猫': '平台-淘宝',
  京东: '平台-京东',
  微博: '平台-微博',
  拼多多: '平台-拼多多',
  唯品会: '平台-唯品会',
  美团: '平台-美团',
  罗麦: '平台-罗麦',
  undefined: '平台-其他',
  其他: '平台-其他',
}
export const authoriedPlatformCode = {
  唯品会: 'wphcode',
  '淘宝/天猫': 'code',
  京东: 'code',
  微博: 'code',
  美团: 'code',
}

export const allCodes = Object.values(authoriedPlatformCode)
